import React from "react";
import ReactDOM from "react-dom/client";
import { App as CapacitorApp } from "@capacitor/app";
import { Capacitor } from "@capacitor/core";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { registerSW } from "virtual:pwa-register";
import "@fontsource-variable/newsreader";
import "@fontsource-variable/manrope";
import "./styles.css";
import "./v21.css";
import App from "./App";

const isCapacitorNative = Capacitor.isNativePlatform();
const isElectron = navigator.userAgent.includes("Electron");

if (window.isSecureContext && !isCapacitorNative && !isElectron) {
  registerSW({ immediate: true });
}

if (isCapacitorNative) {
  void CapacitorApp.addListener("backButton", ({ canGoBack }) => {
    if (canGoBack || window.location.pathname !== "/") {
      window.history.back();
      return;
    }
    void CapacitorApp.minimizeApp();
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: 1,
      refetchOnWindowFocus: false
    }
  }
});

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);

